import React from "react";
import "./Services-list.css";
import { Fade } from "react-reveal";
import { Icon } from "@iconify/react";

export default function ServicesCard({ serv, theme }) {

    return (
        <div
            className="services-card"
            style={{ backgroundColor: theme.dark, color: theme.text }}
        >
            <Fade bottom duration={2000} distance="40px">
                <div key={serv.id}>
                    <div className="services-card-header">
                        <h3 className="services-title" style={{ color: theme.text }}>{serv.name}</h3>
                    </div>

                    <p className="services-description" style={{ color: theme.secondaryText }}>{serv.description}</p>

                    <div className="services-icons">
                        {serv.icon.map((icon, index) => (
                            <Icon icon={icon.iconifyClass} className="service-icon" title={icon.name} />
                        ))}
                    </div>
                    <p className="services-date" style={{ color: theme.secondaryText }}>Publié le : {new Date().toLocaleDateString()}</p>
                </div>
            </Fade>
        </div>

    );
}
